<style>

    html, body {
        position: relative;
        height: 100%;
        font-size: 12px;
    }

    body:after{
        background-image: url(./../imgs/public_relation_bg_img_a.jpg);
    }

    a:link{
        color: rgb(211, 165, 113) !important;
    }

    a:visited {
        color: rgb(211, 165, 113) !important;
    }
    a:hover {
        color: rgb(211, 165, 113) !important;
    }
    a:active {
        color: rgb(211, 165, 113) !important;
    }

    .info-style {
        padding: 20px 0 10px 0;
    }
    @media (min-width: 768px) {
        .info-style {
            padding: 0 0 0 30px;
        }
    }

    .list-style {
        margin: 0 20px 80px 20px;
        padding: 0 30px 20px 30px;
        background-color: #FFFFFF;
    }
    @media (min-width: 768px) {
        .list-style {
            margin: 0 20px 80px 20px;
            padding: 0 30px 30px 30px;
            background-color: #FFFFFF;
        }
    }

</style>

<template>

    <div class="container" style="padding: 0;">

        <div class="tx-page-title">
            {{ $t("relation_title") }}
        </div>
        <div class="tx-page-subtitle">
            {{ $t("relation_subtitle") }}
        </div>

        <div class="container-fluid list-style">

            <div v-for="news in list">

                <!--新闻-->
                <div class="col-xs-12" style="padding: 30px 0 0 0;">

                    <!--图片-->

                    <div class="col-xs-12 col-sm-4" style="padding: 0;">
                        <a :href="news.url" target="_blank">
                        <img v-bind:src="news.image" style="width: 100%;">
                        </a>
                    </div>

                    <div class="col-xs-12 col-sm-8 info-style">

                        <!--标题-->
                        <div class="col-xs-12" style="padding: 0">
                            <a :href="news.url" target="_blank" style="font-size: 18px; color: #4A4A4A!important;text-decoration: none">
                            {{ nls(news.title) }}
                            </a>
                        </div>

                        <!--简介-->
                        <div class="col-xs-12" style="padding: 10px 0 10px 0; font-size: 16px; color: #9B9B9B;">
                            {{ nls(news.brief) }}&nbsp;&nbsp;&nbsp;[&nbsp;{{ news.date }}&nbsp;]
                        </div>

                        <!--链接-->
                        <div class="col-xs-12" style="padding: 0; font-size: 16px;">
                            <a :href="news.url" target="_blank">
                                {{ $t("relation_more") }}
                            </a>
                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>

</template>

<script>

    module.exports = {
        data: function () {
            return {
                list: window.pubData.news
            }
        },
        methods: {
            nls: function (val) {
                return val[this.$i18n.locale];
            }
        },
        mounted: function () {
            window.pageTitle = {
                en_US: this.$i18n.messages.en_US.page_title_public_relation,
                zh_HK: this.$i18n.messages.zh_HK.page_title_public_relation,
                zh_CN: this.$i18n.messages.zh_CN.page_title_public_relation
            }
            window.setTitle(window.pageTitle[this.$i18n.locale]);


        }
    }

</script>


// WEBPACK FOOTER //
// public_relation.vue?55c3e64a